export const JockeyStatisticsMockData = {
    name: "L Hewitson",
    career: "30:8-2-5",
    previousRaces: [
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Sean Tarry',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        }
    ]
};